module.exports = require("./ff-Latn-SL.js");